// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2ca86739","551":"42565d4a"}[chunkId] + ".chunk.js";
};